<template>
  <div>
    <div class="header">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item>会议</a-breadcrumb-item>
        <a-breadcrumb-item><router-link :to="{ path: '/meeting/list' }">已排会</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>会议详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>

    <div class="content">
      <template v-if="isPermission">
        <a-skeleton active :paragraph="{ rows: 20 }" v-if="!meetingDetail" />
        <meeting-item 
          v-else 
          :company-id="companyId" 
          :info="meetingDetail || {}"
          @refresh="refresh"
          >
          <router-link
             data-ga-id="会议详情-点击同一会议关联项目"
            v-if="projectMeetingListPermission"
            slot="headerExtra"
            :to="{ path: '/project/meetingList', query: { companyId: companyId, meetingProjectId: meetingId } }"
            >同一项目关联会议列表</router-link
          >
        </meeting-item>
      </template>

      <a-result v-else status="403" title="对不起，您没有此页面的访问权限"> </a-result>
    </div>
  </div>
</template>
<style lang="less" scoped>
.header {
  background: #fff;
  position: fixed;
  top: 46px;
  left: 0;
  right: 0;
  z-index: 1;
  padding: 5px 20px 0 20px;
  border-bottom: #f5f5f5 1px solid;
}
/deep/ .ant-tabs-bar {
  margin: 0;
}
.content {
  margin-top: 50px;
}
.breadcrumb {
  margin: 10px;
}
</style>

<script>
import MeetingItem from '@/components/meeting/meetingDetail/meetingItem.vue';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import moment from 'moment';
import { meetProjectList } from '@/api/meeting';
import { meetingGoalMap } from '@/utils/meeting';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';

export default {
  components: {
    MeetingItem: MeetingItem
  },
  data() {
    return {
      meetingDetail: undefined,
      activeItem: 1,
      isListenScroll: true,
      isPermission: true,
      projectMeetingListPermission: true
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    companyId() {
      return parseInt(this.$route.query.companyId);
    },
    meetingId() {
      return parseInt(this.$route.query.meetingProjectId);
    }
  },
  mounted() {
    const { permissions: queue } = this.userInfo || {};
    this.projectMeetingListPermission = hasPermission(queue, '/project/meetingList');
    meetProjectList({ companyId: this.companyId }).then(res => {
      if (res.code === 200) {
        res.data.forEach((i, index) => {
          if (this.meetingId === i.baseInfo.id) {
            i.baseInfo.companyId = this.companyId;
            this.$set(this, 'meetingDetail', i);
          }
        });
      } else {
        this.isPermission = false;
      }
    });
  },
  methods: {
    refresh() {
      meetProjectList({ companyId: this.companyId }).then(res => {
        if (res.code === 200) {
          res.data.forEach((i, index) => {
            if (this.meetingId === i.baseInfo.id) {
              i.baseInfo.companyId = this.companyId;
              this.$set(this, 'meetingDetail', i);
            }
          });
        } else {
          this.isPermission = false;
        }
      });
    }
  }
};
</script>

<style></style>
